import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type MoySkladCommissionerContractSettingsRequest as SchemaMoySkladCommissionerContractSettingsRequest } from '../schemas/MoySkladCommissionerContractSettingsRequest';
import { type MoyskladOrderSetupProblemType as SchemaMoyskladOrderSetupProblemType } from '../schemas/MoyskladOrderSetupProblemType';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const SetupMoyskladComissionerContractIntegrationContentType = 'application/json' as const;
export type SetupMoyskladComissionerContractIntegrationRequest = SchemaMoySkladCommissionerContractSettingsRequest;
export type SetupMoyskladComissionerContractIntegrationResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {};
    /**
     * @description Invalid input or validation error
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaMoyskladOrderSetupProblemType;
        };
    };
};
export type SetupMoyskladComissionerContractIntegrationResponseSuccess = undefined;
export type SetupMoyskladComissionerContractIntegrationSearchParams = undefined;
export type SetupMoyskladComissionerContractIntegrationPathParameters = undefined;
export const SetupMoyskladComissionerContractIntegrationUrl =
    '/integrations/moysklad/setup/commissioner_contracts' as const;
export const SetupMoyskladComissionerContractIntegrationMethod = 'POST' as const;
export const getSetupMoyskladComissionerContractIntegrationUrl = (
    _params?: SetupMoyskladComissionerContractIntegrationPathParameters
) => SetupMoyskladComissionerContractIntegrationUrl;
